// extracted by mini-css-extract-plugin
export var createdDate = "_j5-1";
export var divider = "_j5-2";
export var headerDivider = "_j5-3";
export var messagesCard = "_j5-0";
export var messagesContainer = "_j5-6";
export var messagesContainerWrapper = "_j5-4";
export var showLeftPanelButton = "_j5-8";
export var topButtons = "_j5-7";
export var withPadding = "_j5-5";